<div class="app-body">
    <router-outlet></router-outlet> 
</div>

